<!--*****************************************************************
  * Copyright (c) Certus Software, 2022.                            *
  *                                                                 *
  * This unpublished material is proprietary to Certus Software.    *
  * All rights reserved. The methods and techniques described       *
  * herein are considered confidential and/or trade secrets.        *
  * Reproduction or distribution, in whole or in part, is forbidden *
  * except by express written permission of Certus Software.        *
  *****************************************************************-->

<router-outlet (activate)="onActivate($event)"></router-outlet>
